// extracted by mini-css-extract-plugin
module.exports = {"post":"List_post__3rE6M","title":"List_title__3aUKm","date":"List_date__2VjFd"};